import { useEffect } from 'react'
import isEditableTarget from 'utils/isEditableTarget'
import { ImageShortcutAction, matchShortcut } from './shortcuts'

/**
 * Liga os atalhos de teclado das ferramentas da imagem no `window` enquanto o componente está
 * montado. Ignora teclas digitadas em campos de texto e durante a composição de IME.
 */
const useImageShortcuts = (
  handlers: Record<ImageShortcutAction, () => void>
) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.defaultPrevented ||
        event.isComposing ||
        isEditableTarget(event.target)
      ) {
        return
      }

      const action = matchShortcut(event)
      if (!action) return

      event.preventDefault()
      handlers[action]()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handlers])
}

export default useImageShortcuts
